import DataDisplayRowI from "../DataDisplayRowI";
import getStoreItemRow from "../DataDisplayRow/StoreItemRow";
import DataDisplayTable from "../DataDisplayTable";

class StoreItemTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getStoreItemRow()
    }
}

let storeItemTable: StoreItemTable | null = null;

export default function getStoreItemTable(): StoreItemTable {
    if (storeItemTable === null)
        storeItemTable = new StoreItemTable()
    return storeItemTable
}